import { makeStyles, Typography } from "@material-ui/core";
import cl from "classnames";
import { get } from "lodash";
import React from "react";
import {
	ArrayInput,
	FormDataConsumer,
	NumberInput,
	required,
	SimpleFormIterator,
	useTranslate,
} from "react-admin";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
	arrayInput: {
		display: "inline-block",
		width: 200,
		float: "left",
		marginRight: theme.spacing(1),
	},
	amountCheatInput: {
		width: 200,
	},
	suffix: {
		padding: 20,
	},
}));
const OptionableNumberInput = ({ rootSource, event, formData, ...props }) => {
	// Ask Frank to put a fucking index value into the
	// SimpleFormIterator to avoid this fucking shit.
	const id = parseInt(props.id.replace("items[", "").replace("]", ""), 10);
	const list = get(formData, rootSource, []);
	const classes = useStyles();
	const translate = useTranslate();
	if (list.length > 0 && id < list.length - 1)
		return (
			<>
				<NumberInput {...props} validate={required()} />
				<Typography className={classes.suffix} variant="body1" component="div">
					{translate(`resources.events.code.${get(event, "name")}`)}
				</Typography>
			</>
		);

	return null;
};

const AmountCheatInput = ({ getSource, className, ...props }) => {
	// Ask Frank to put a fucking index value into the
	// SimpleFormIterator to avoid this fucking shit.
	const id = parseInt(props.id.replace("items[", "").replace("]", ""), 10);
	const classes = useStyles();
	const inputProps = {
		...props,
		label: "resources.bookmaker-deals.fields.amount_cheat",
		source: getSource("amount_cheat"),
		className: cl(className, classes.amountCheatInput),
		helperText:
			id === 0 ? "resources.bookmaker-deals.helpers.amount_cheat" : null,
	};
	return <NumberInput {...inputProps} />;
};

const ItemsInput = ({ dispatch, events, ...props }) => {
	const classes = useStyles();
	const disableRemove = (currentRecord, formData) => {
		return get(formData, "items", []).length === 1;
	};
	return (
		<FormDataConsumer {...props}>
			{({ formData, ...rest }) => {
				const eventId = get(formData, "event_id");
				const eventRevCodeId = 5;
				return (
					<ArrayInput {...props}>
						<SimpleFormIterator
							disableRemove={(record) => disableRemove(record, formData)}
						>
							<FormDataConsumer>
								{({ formData, scopedFormData, getSource, ...rest }) => (
									<>
										<NumberInput
											{...rest}
											label="resources.bookmaker-deals.fields.amount"
											source={getSource("amount")}
											className={classes.arrayInput}
											validate={required()}
										/>
										{eventId === eventRevCodeId && (
											<AmountCheatInput
												{...rest}
												getSource={getSource}
												className={classes.arrayInput}
											/>
										)}
										<OptionableNumberInput
											{...rest}
											label="resources.bookmaker-deals.fields.value_limit"
											source={getSource("value_limit")}
											className={classes.arrayInput}
											formData={formData}
											rootSource={props.source}
											event={events[formData.event_id]}
										/>
									</>
								)}
							</FormDataConsumer>
						</SimpleFormIterator>
					</ArrayInput>
				);
			}}
		</FormDataConsumer>
	);
};

export default connect((state) => ({
	events: get(state, "admin.resources.events.data", {}),
}))(ItemsInput);
